import React from 'react'

import {
  CurriculumIcon,
  IndustryExpertIcon,
  JobsIcon,
  MentorShipIcon,
  OnlineIcon,
  WorkExperienceIcon
} from '../assets/icons'

const features = [
  {
    icon: IndustryExpertIcon,
    title: 'Industry Experts',
    description:
      'Top 3% of Tech Leaders to mentor YOU after gaining world-class experience over years of practice.'
  },
  {
    icon: CurriculumIcon,
    title: 'Curriculum',
    description:
      'Specialised curriculum with multiple projects to make you 2026 ready, created by tech leaders from FAANG.'
  },
  {
    icon: WorkExperienceIcon,
    title: 'Work Experience',
    description:
      'Work at Top tech companies and startups to gain real world Industry experience.'
  },
  {
    icon: OnlineIcon,
    title: 'Online',
    description:
      'Fully Remote as we make you industry ready and becoming a remote engineer in a global company.'
  },
  {
    icon: JobsIcon,
    title: 'Jobs',
    description:
      '100% Placement assistance and dedicated career support and guidance to help learners land jobs at top tech companies.'
  },
  {
    icon: MentorShipIcon,
    title: 'Personalised Mentorship',
    description: 'Get personalised Mentorship and Support from tech experts.'
  }
]

const FeaturesSection = () => {
  return (
    <section className="bg-[#3C3C78] text-white">
      <div className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-12 w-full">
        <h3 className="text-center text-3xl md:text-4xl font-semibold tracking-tight">
          Why Us?
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="flex flex-col px-6 py-8 gap-y-4 bg-[#484889] rounded-md shadow border border-[#6969B4] text-base md:text-lg lg:text-xl">
              <feature.icon className={'w-12 h-12'} />
              <h3 className="tracking-tight font-semibold">{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FeaturesSection
